export const KEY_INFO = {
    INCREASE_FONTSIZE: 'font-size',
    VALUE_LARGE_INCREASE_FONTSIZE: 'large',
    VALUE_NORMAL_INCREASE_FONTSIZE: 'normal',
};
